/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const HOLDER_CAN_ABILITY = [
  //Route Access
  ["read", "MyProfile"],
  ["read", "OrgProfile"],
  ["read", "DashboardOverview"],
  ["read", "IssuedCredentialList"],
  ["read", "IssuedNetworkGraph"],
  ["read", "MyCredentials"],
  ["read", "Credential"],
  ["read","ViewCredential"],
  ["read", "PortfolioList"],
  ["read", "CreateEPortfolio"],
  ["read", "CreatedEPortfolio"],
  ["read", "DraftEPortfolio"],
  ["read", "ListedHolderEPortfolio"],
  ["read", "ReviewedEPortfolio"],
  ["read", "ReviewEPortfolio"],
  ["read","ApproveEPortfolio"],
  ["read", "ListedEPortfolioDetail"],
  ["read", "Services"],
  ["read", "VerifyPortfolioCredential"],
  ["read", "SelfAttestedTemplates"],
  ["read", "IssueNewSelfAttestedCredential"],
  ["read", "SelfAttestedUnderReviewTemplates"],
  ["read", "SelfAttestedUnderReviewCredential"],
  ["read", "SelfAttestedUnderReviewCredentials"],
  ["read","CreatePortfolioTemplate"],
  ["read","PortfolioTemplates"],
  ["read","PortfolioUnderApproval"],
  ['read', 'PortfolioCertTemplates'],
  ['read', 'PortfolioCertificates'],
  ["read", "UnderReviewEPortfolio"],
  ["read","UnderReviewEPortfolioTemplates"],
  ["read","UnderReviewEPortfolioCertificates"],
  ["read","ApprovedHolderEPortfolio"],
  ["read","ApprovedHolderEPortfolioTemplates"],
  ["read","ApprovedHolderEPortfolioCertificates"],
  ["read","ListedHolderEPortfolioTemplates"],
  ["read","ListedHolderEPortfolioCertificates"]
];

export const HOLDER_CANNOT_ABILITY = [
  //Route Access Denial
  //  ["read", "Button"],
];
